/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ names: NonNullable<unknown> }} Action_Bar_Noshow_NoticeInputs */



/**
* | output |
* | --- |
* | "Not checked in, marked no-show when Round 1 starts (can be reinstated if they arrive): {names}" |
*
* @param {Action_Bar_Noshow_NoticeInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const action_bar_noshow_notice = /** @type {((inputs: Action_Bar_Noshow_NoticeInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Action_Bar_Noshow_NoticeInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Pas pointés, marqués absents au début de la ronde 1 (réintégrables s'ils arrivent) : ${i?.names}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Sin check-in, se marcarán ausentes al empezar la ronda 1 (se pueden readmitir si llegan): ${i?.names}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Sem check-in, marcados como ausentes no início da rodada 1 (podem ser readmitidos se chegarem): ${i?.names}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Senza check-in, segnati assenti all'inizio del round 1 (riammissibili se arrivano): ${i?.names}`)
	return /** @type {LocalizedString} */ (`Not checked in, marked no-show when Round 1 starts (can be reinstated if they arrive): ${i?.names}`)
});